export default __webpack_public_path__ + "media/images/equations/ltl_order-6e61ce5c025443ed3d955b4ecb4fddcd.png";